import { HmacSHA256, lib, TripleDES, mode, enc, MD5 } from "crypto-js";
import Base64 from 'crypto-js/enc-base64';
import utf8 from 'crypto-js/enc-utf8';
import { RdContextType } from "../@types/Rd";


export const ProtectKeyContext = (key: string): string => {
    const array: lib.WordArray = HmacSHA256(key, `CTX-S${key}`),
        result = array.toString(Base64);
    return result;
}

export const EncryptContext = (key: string, value: RdContextType & { [identifier: string]: any }): string => {
    const hashKey = ProtectKeyContext(key),
        serialized: string = JSON.stringify(value),
        result: string = TripleDES.encrypt(serialized, hashKey).toString()

    return result;
}

export const DecryptContext = (key: string, ciphertext: string): string => {
    const hashKey = ProtectKeyContext(key),
        digest = TripleDES.decrypt(ciphertext, hashKey),
        result = digest.toString(utf8);

    return result;
}

export const ProtectKeyText = (key: string, salt: string = "TXT-"): lib.WordArray => {
    const
        keyArray = enc.Utf8.parse(key),
        saltArray = enc.Utf8.parse(`${salt}${key}`),
        result = HmacSHA256(keyArray, saltArray);
    return result;
}

export const EncryptText = (key: string, value: string, salt: string = "TXT-"): string => {
    const keyArray = MD5(enc.Utf8.parse(`${salt}${key}`));
    keyArray.words.push(keyArray.words[0], keyArray.words[1]);


    const options = { mode: mode.ECB },
        valueArray = enc.Utf8.parse(value),
        result: string = TripleDES.encrypt(valueArray, keyArray, options).toString();

    return result;
}

export const DencryptText = (value: string, key: string, salt: string = "TXT-"): string => {
    const keyArray = MD5(enc.Utf8.parse(`${salt}${key}`));
    keyArray.words.push(keyArray.words[0], keyArray.words[1]);

    const options = { mode: mode.ECB },
        result: string = enc.Utf8.stringify(TripleDES.decrypt(value, keyArray, options));

    return result;
}